import React from 'react'
import * as Layout from '../../components/layout'
import * as Menu from '../../components/menu/constants'

export const routes = [
  {
    action: () => import(/* webpackChunkName: "IpPoolsPage" */'./component')
      .then(({IpPoolsConnected}) => <Layout.Layout>
        <IpPoolsConnected/>
      </Layout.Layout>),
    path: Menu.ADMIN_IP_POOLS_URL,
  },
]



// WEBPACK FOOTER //
// ./src/pages/ip-pools/routes.tsx